<template>
    <div>
        <v-app>
            <v-data-table :headers="headers" :items="actions" :items-per-page="5" :sort-desc="[false, true]" hide-default-footer class="paginated-table table-striped">
                <template v-slot:top>
                    <v-btn tile small color="success" @click="showAddAction">
                        <v-icon left> mdi-plus</v-icon>
                        新增
                    </v-btn>
                </template>
                <template v-slot:item.template="{ item }">{{ templateMap[item.template] }}</template>
                <template v-slot:item.option="{ item }">
                    <md-button class="md-just-icon md-success md-round md-simple" @click.native="showEditAction(item)" style="padding-right: 30px;">
                        <md-icon>edit</md-icon>
                    </md-button>
                    <md-button class="md-just-icon md-danger md-round md-simple" @click.native="delAction(index)">
                        <md-icon>close</md-icon>
                    </md-button>
                </template>
            </v-data-table>
            <v-dialog v-model="showActDialog" persistent max-width="600px">
                <v-form @submit.prevent="setAction">
                    <v-card class="window-card">
                        <v-card-title>
                            <span class="md-title" style="color: #67ad5b">动作定义</span>
                        </v-card-title>
                        <v-card-text>
                            <v-text-field v-model="form.name" label="动作名称 *" :rules="[v => !!v || '动作名称不能为空']"></v-text-field>
                            <v-select v-model="form.template" :items="scene_obj_list" item-text="name" item-value="value" label="动作模板"></v-select>
                            <v-text-field v-model="form.animResource" label="动画资源 *" :rules="[v => !!v || '动画资源不能为空']" v-show="form.template === 'bfdh'"></v-text-field>
                            <v-text-field v-model="form.playSpeed" label="播放速率" :rules="[v => !!v || '播放速率不能为空']" v-show="form.template === 'bfdh'"></v-text-field>
                            <md-field v-show="form.template === 'bfdh'">
                                <div class="md-layout">
                                    <div class="md-layout-item md-size-20">
                                        <label style="padding-top: 5px">是否倒播</label>
                                    </div>
                                    <div class="md-layout-item md-size-75">
                                        <v-switch v-model="form.replay"></v-switch>
                                    </div>
                                </div>
                            </md-field>
                            <v-radio-group v-model="form.type">
                                <v-radio label="动态参数：允许在任务中进行动态设置" value="dynamic"></v-radio>
                                <v-radio label="静态参数：固定在当前定义的动作内部" value="static"></v-radio>
                            </v-radio-group>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" small type="submit">确 定</v-btn>
                            <v-btn color="success" small @click="showActDialog = false">关 闭</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <v-dialog v-model="showAddDialog" max-width="600px">
                <v-form @submit.prevent="addTable">
                    <v-card class="window-card">
                        <v-card-title>
                            <span class="md-title" style="color: #67ad5b">新增坐标</span>
                        </v-card-title>
                        <v-card-text>
                            <v-text-field @change="changeMap" v-model="zbForm.attr" label="属性值 *" :rules="[v => !!v || '属性值不能为空']"></v-text-field>
                            <v-text-field @change="changeMap" v-model="zbForm.coordinate" label="移动坐标 *" :rules="[v => !!v || '移动坐标不能为空']" hint="浮点数数组,保留两位小数,如:10.18,10.19,10.20" v-if="form.behaviorTypeId === 'lsyd'"></v-text-field>
                            <v-text-field @change="changeMap" v-model="zbForm.rotationAngle" label="旋转角度 *" :rules="[v => !!v || '旋转角度不能为空']" hint="浮点数数组,保留两位小数,如:10.18,10.19,10.20" v-if="form.behaviorTypeId === 'lsxz'"></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" small type="submit">确 定</v-btn>
                            <v-btn color="success" small @click="showAddDialog = false">关 闭</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-app>
    </div>
</template>
<script>
import { upload } from '@/api/user';

export default {
    name: 'ActTab',
    props: {
        extDataList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            headers: [
                { text: '名称', align: 'center', value: 'name' },
                { text: '类型', align: 'center', value: 'template' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            showActDialog: false,
            showAddDialog: false,
            form: {},
            zbForm: {},
            actions: [],
            scene_obj_list: [
                { value: 'bfdh', name: '播放动画' }
            ],
            templateMap: {
                'bfdh': '播放动画',
            }
        }
    },
    mounted() {
        this.initForm()
    },
    methods: {
        init(form) {
            if (typeof form === 'object') {
                this.actions = form
            }
        },
        initForm() {
            this.form = {
                name: '',
                description: '',
                extendedPropertiesId: '',
                behaviorTypeId: '',
                zdh_name: '',
                rate: '',
                direction: '',
                moveData: [],
                propertyRange: [],
                angleRange: [],
                moveRange: [],
                proportion: '',
                rotData: [],
                file: [],
                files: ''
            }
        },
        showAddAction() {
            this.showActDialog = true
            this.initForm()
        },
        addTable() {
            const dict = {
                lsxz: 'rotData',
                lsyd: 'moveData'
            }
            this.form[dict[this.form.behaviorTypeId]].push(this.zbForm)

            this.showAddDialog = false
        },
        showZbForm() {
            this.showAddDialog = true
            this.zbForm = {}
        },
        changeMap() {
            this.form.isChange = true
        },
        onFileChange(files) {
            if (!files.length) return
            this.createImage(files[0])
        },
        handleDelete(index, keyName) {
            this.form[keyName].splice(index, 1)
        },
        createImage(file) {
            this.form.files = ''
            let reader = new FileReader()

            reader.onload = (e) => {
                // this.user.avatar = e.target.result;
            }
            reader.readAsDataURL(file)
            let formData = new FormData()
            formData.append('deviceFile', file)
            // let params = configApi.upload(formData)
            // params.headers = {
            //   'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq'
            // }
            // api
            //   .$axios(params)
            //   .then((res) => {
            //     if (res.data.code === '200') {
            //       // this.basicPropertyMap.icon = res.data.data.url;
            //       this.form.file.push(res.data.data)
            //       this.$message.success('上传成功')
            //       this.form.files = ''
            //     }
            //   })
            //   .catch(() => { })

            upload(formData).then((res) => {
                if (res.code === '200') {
                    this.form.file.push(res.data)
                    this.$message.success('上传成功')
                    this.form.files = ''
                }
            })
        },
        setAction() {
            this.form.behaviorTypeId = this.form.template
            if (this.form.id) {
                const actIndex = this.actions.findIndex((item) => item.id === this.form.id)
                this.actions[actIndex] = this.form
            } else {
                this.form.id = `scene_act_${new Date().getTime()}`
                this.actions.push(this.form)
            }
            this.initForm()
            this.showActDialog = false
        },
        showEditAction(item) {
            this.form = item
            this.showActDialog = true
        },
        delAction(index) {
            this.actions.splice(index, 1)
        }
    }
}
</script>
<style>
</style>